<!-- 部门结构树 -->
<template>
  <div>
    <el-tree
      ref="depTree"
      :data="frameTree"
      :accordion="true"
      :props="defaultProps"
      :expand-on-click-node="false"
      default-expand-all
      highlight-current
      node-key="deptId"
      @current-change="currentOrgChangeHandler"
    >
      <template #default="{ data }">
        <div style="display: flex; align-items: center">
          <img :src="icon" style="margin-right: 6px" alt="部门图片" />
          <span style="font-size: 14px">{{ data.deptName }}</span>
        </div>
      </template>
    </el-tree>
  </div>
</template>

<script>
import supplierService from "@/xgzdService/supperson-service";
import orgService from "@/CommonDP/service/org-service";
import { mapState } from "vuex";
export default {
  props: ["addType"],

  data() {
    return {
      frameTree: [],
      defaultProps: {
        children: "children",
        label: "deptName",
      },
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
    };
  },

  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
    }),
  },

  created() {
    this.frameTree = [];
    if (this.addType === "0") {
      //内部部门
      this.getInteriorTree();
    } else {
      //外部部门
      this.getFrameTree();
    }
  },

  methods: {
    async getFrameTree() {
      const params = {
        enterpriseId: this.enterpriseId,
      };
      return supplierService.getOrgTree(params).then(({ data }) => {
        data = data || [];
        const [firstData] = data;
        this.frameTree = data;
        if (!firstData) return;
        this.$emit("depChange", firstData);
        this.$nextTick(() => {
          this.$refs.depTree.setCurrentKey(firstData.deptId);
        });
      });
    },

    async getInteriorTree() {
      const { enterpriseId } = this;
      return orgService.getOrgTree(enterpriseId).then(({ data }) => {
        data = data || [];
        const [firstData] = data;
        this.frameTree = data;
        if (!firstData) return;
        this.$emit("depChange", firstData);
        this.$nextTick(() => {
          this.$refs.depTree.setCurrentKey(firstData.deptId);
        });
      });
    },

    currentOrgChangeHandler(val) {
      this.$emit("depChange", val);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
